import {ChangeDetectionStrategy, Component, computed, DestroyRef, inject, signal} from "@angular/core"
import {BrushSettingsPanelComponent} from "@app/textures/texture-editor/operator-stack/operators/shared/panel/brush-settings-panel/brush-settings-panel.component"
import {ButtonComponent} from "@common/components/buttons/button/button.component"
import {ToggleComponent} from "@common/components/buttons/toggle/toggle.component"
import {HintComponent} from "@common/components/hint/hint.component"
import {Hotkeys} from "@common/services/hotkeys/hotkeys.service"
import {OperatorCloneStamp} from "@app/textures/texture-editor/operator-stack/operators/clone-stamp/operator-clone-stamp"
import {BrushSettings} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/brush-strokes/definition"
import {isApple} from "@cm/browser-utils"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"
import {OperatorPanelBase} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator-panel-base"
import {filter} from "rxjs"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-clone-stamp-panel",
    templateUrl: "./clone-stamp-panel.component.html",
    styleUrls: ["./clone-stamp-panel.component.scss"],
    imports: [HintComponent, ButtonComponent, InspectorSectionComponent, BrushSettingsPanelComponent, ToggleComponent],
})
export class CloneStampPanelComponent extends OperatorPanelBase<OperatorCloneStamp> {
    private readonly destroyRef = inject(DestroyRef)
    private readonly hotkeys = inject(Hotkeys)

    constructor() {
        super()
        this.hotkeys
            .addShortcut("undo")
            .pipe(
                filter(() => !this.$disabledEdits()),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe(() => this.undoClicked())
    }

    readonly $showMask = computed(() => this.$operator().$showMask())

    protected setShowMask(value: boolean) {
        this.$operator().setShowMask(value)
    }

    readonly $canUndo = computed(() => this.$operator().$canUndoStroke())

    undoClicked(): void {
        this.$operator().undoStroke()
    }

    readonly $brushSettings = computed(() => this.$operator().$brushSettings())

    protected setBrushSettings(value: BrushSettings) {
        this.$operator().setBrushSettings(value)
    }

    readonly $isApple = signal(isApple)
}
